<template>
  <div>
    <loader :loader="sending" />
    <v-data-table
      :headers="headers"
      :items="listHistoy"
      :items-per-page="itemsPerPage"
      no-data-text="Sin resultados disponibles"
      class="mx-5"
      dense
      fixed-header
      height="auto"
      hide-default-footer
    >
      <template v-slot:[`item.startDate`]="{ item }">
        {{ $utilFront.formatDateTime(item.startDate) }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <status-study :statusStudy="item.status" />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip left color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="viewData(item)" small>
              <v-icon color="primary" v-bind="attrs" v-on="on">
                mdi-information-variant
              </v-icon>
            </v-btn>
          </template>
          <span>Información</span>
        </v-tooltip>

        <v-menu
          offset-y
          :nudge-width="105"
          :close-on-content-click="true"
          v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM)"
        >
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip left color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <span>Más opciones</span>
            </v-tooltip>
          </template>

          <v-list dense>
            <v-list-item
              link
              dense
              @click="downloadDicomZip(item)"
              v-if="
                item.status >= 5 &&
                $utilFront.withPermission($prm.DOWNLOAD_DICOM)
              "
            >
              <v-list-item-icon>
                <v-icon color="blue" small> mdi-folder-download </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span>DICOM</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              dense
              @click="generareteLinkDownload(item)"
              v-if="
                item.status >= 5 &&
                $utilFront.withPermission($prm.GENERATE_LINK_STUDY)
              "
            >
              <v-list-item-icon>
                <v-icon color="gray" small> mdi-link </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span>Link de descarga</span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              link
              @click="shareByWhatsApp(item)"
              v-if="
                item.status >= 5 &&
                $utilFront.withPermission($prm.SHARE_WHATSAPP_IMG)
              "
            >
              <v-list-item-icon>
                <v-icon color="success" small> mdi-whatsapp </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  <span> Enviar por whatsApp </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <view-image-item
              v-if="$utilFront.withPermission($prm.VIEWER_WEB_IMG)"
              :send="() => (sending = !sending)"
              :idStudy="item.idStudy"
              :small="true"
            />
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <v-card-actions align="center" class="mt-4 ml-2">
      <v-col>
        <v-btn
          outlined
          small
          color="green darken-1"
          :disabled="sending"
          @click="downloadReportXLSX()"
        >
          Exportar datos
          <v-icon right>mdi-microsoft-excel</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-dialog
      v-model="dialogCancelation"
      persistent
      max-width="70%"
      v-if="dialogCancelation"
    >
      <cancelation-modal
        :dataModal="dataModal"
        @closeCancelationDialog="closeCancelationDialog"
        :dialogCancelation="dialogCancelation"
      />
    </v-dialog>
  </div>
</template>

<script>
import MenuCrud from "@/app/components/base/menu/MenuCrud.vue";
import StatusStudy from "@/app/components/image/StatusStudy.vue";
import CancelationModal from "@/app/components/common/CancelationModal.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import ViewImageItem from "@/app/components/common/study/ViewImageItem.vue";
import { InterpretationHistoryService } from "@/app/services";
import RouteConstants from "@/app/core/RouteConstants";

import {
  ReportPDFRequest,
  DownloadZipRequest,
  StudyRequest,
} from "@/core/request";
export default {
  name: "SpecialityTable",
  props: {
    list: Array,
    get: Function,
    deleteItem: Function,
    itemsPerPage: Number,
    biRadsSelect: Number,
    listAllPagination: Function,
    getAddendums: Function,
    search: String,
    range: Object,
    idBranchOffice: String,
    idModality: String,
  },
  components: {
    MenuCrud,
    CancelationModal,
    Loader,
    ViewImageItem,
    StatusStudy,
  },
  data() {
    return {
      dialogCancelation: false,
      dataModal: {},
      listHistoy: [],
      sending: false,
      headers: [
        {
          text: "Id Estudio",
          value: "idStudy",
          align: "center",
          sortable: false,
        },
        {
          text: "Accession Number",
          value: "accessionNumber",
          align: "center",
          sortable: false,
        },
        {
          text: "Id Paciente",
          value: "idPatient",
          align: "center",
          sortable: false,
        },
        {
          text: "Nombre del paciente",
          value: "fullNamePatient",
          sortable: false,
          align: "center",
        },
        {
          text: "Modalidad",
          value: "fullNameModality",
          sortable: false,
          align: "center",
        },
        {
          text: "Estudio",
          value: "fullNameStudyProfile",
          sortable: false,
          align: "center",
        },
        {
          text: "Estatus",
          value: "status",
          sortable: false,
          align: "center",
        },
        {
          text: "Fecha de inicio",
          value: "startDate",
          sortable: false,
          align: "center",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  watch: {
    list: function () {
      this.setlistWithBiradsChanges();
    },
  },
  methods: {
    downloadDicomZip({ idStudy, fullNamePatient }) {
      this.sending = true;
      const params = { idStudy };
      DownloadZipRequest.downloadImagesDCM(params)
        .then(({ data }) => {
          this.$utilFront.downloadZIP(
            data,
            `${idStudy}_${fullNamePatient}_DICOM.zip`
          );
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    generareteLinkDownload({ idStudy }) {
      this.sending = true;
      let params = { idStudy };
      DownloadZipRequest.generateDownloadAccessKey(params)
        .then(({ data: responseData }) => {
          if (this.$utilFront.validResponse(responseData)) {
            const accessKey = responseData.data;
            const origin = new URL(location.origin).toString();
            const route_download = RouteConstants.DOWNLOAD_STUDIES.path;
            const route = origin.endsWith("/")
              ? route_download.replace("/", "")
              : route_download;
            const link = origin + route.replace(":idStudy", accessKey);

            this.$utilFront.copyText(link);
          } else {
            this.$utilFront.notifications(
              "Generación del link, no disponible.",
              "ERROR"
            );
          }
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    shareByWhatsApp({ idStudy }) {
      this.sending = true;

      let params = { idStudy };

      StudyRequest.generateLinkToShareWA(params)
        .then(({ data: responseData }) => {
          if (this.$utilFront.validResponse(responseData)) {
            const { data } = responseData;
            const textShare = `https://wa.me/?text=${encodeURIComponent(data)}`;
            window.open(textShare, "_blank");
          } else {
            this.$utilFront.notifications(
              "Generación del link, no disponible.",
              "ERROR"
            );
          }
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.sending = false;
        });
    },
    viewData({idStudy, idPatient, fullNamePatient, status}){
      this.get({idStudy, idPatient, fullNamePatient, status}, 3);
    },

    //Todo: other´s
    setlistWithBiradsChanges() {
      this.listHistoy = this.list.map((obj) => {
        obj.birads = obj.birads ? obj.birads : "NA";
        obj.colorBirads = obj.colorBirads ? obj.colorBirads : "nobirad";
        return obj;
      });
    },
    checkCancel(item) {
      this.dataModal = {};
      this.dataModal = Object.assign(this.dataModal, item);
      this.dataModal.birthDate = this.$utilFront.formatDate(
        this.dataModal.birthDate
      );
      this.dialogCancelation = true;
    },
    closeCancelationDialog(e) {
      this.dialogCancelation = e;
      this.deleteItem();
    },
    downloadViewer(item) {
      try {
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },

    exportToPDF(interpretation) {
      let data = {
        idInterpretation: interpretation.idInterpretation,
        interpretationText: "",
        fileName: "Interpretacion",
      };
      ReportPDFRequest.downloadInterpretation(data);
    },
    changeViewAddendums(item) {
      this.sending = true;
      this.objectInterpretation = item;
      this.getAddendums(item, 1);
    },
    downloadReportXLSX() {
      if (!this.sending) {
        this.sending = true;

        let params = {
          idBirads: this.biRadsSelect,
          search: this.search,
          idBranchOffice:
            this.idBranchOffice != null
              ? this.idBranchOffice
              : this.$utilFront.getIdBranchOffice(),
        };

        if (this.$utilFront.nonEmpty(this.idModality)) {
          params.idModality = this.idModality;
        }

        let rangeName = "";

        if (this.$utilFront.nonEmpty(this.range)) {
          params.start = this.$utilFront.startOfDay(this.range.start);
          params.end = this.$utilFront.endOfDay(this.range.end);
          rangeName = ` del ${this.$utilFront.formatDate(
            params.start
          )} al ${this.$utilFront.formatDate(params.end)}`;
        }

        let fileName = `Historial de interpretaciones${rangeName}.xlsx`;

        InterpretationHistoryService.downloadReportHistoryXLSX(params)
          .then((response) => {
            let { data } = response;
            this.$utilFront.downloadXLSX(data, fileName);
          })
          .catch((error) => {
            this.$utilFront.errorhttp(error);
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
  },
};
</script>
